<template>
<!-- eslint-disable max-len -->
<div :style="{ 'z-index': (order ? order : 0) }" class="player" :class="{ full, right, sf: (starfighter) }">
  <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"> -->
  <img
    v-show="use1"
    :src="narratorImgSrc"
    :style="style"
    :key="avatar._id"
    draggable="false"
    @load="onLoaded"
  >
  <img
    v-show="!use1"
    :src="narratorImgSrc2"
    :style="style2"
    :key="`${avatar._id}-2`"
    draggable="false"
    @load="onLoaded"
  >
  <!-- </transition> -->
  <tooltip :target="tooltipTarget">
  </tooltip>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import Tooltip from './Tooltip';

export default {
  components: {
    Tooltip,
  },
  props: {
    scale: { type: Number, default: 1 },
    angled: { type: Boolean },
    full: { type: Boolean },
    right: { type: Boolean },
    variantOverride: { type: String, default: '' },
    xOffset: { type: String, default: '' },
    yOffset: { type: String, default: '' },
    orderOverride: { type: Number, default: 0 },
    tooltipTarget: { type: String, default: 'characterLeft' },
    extraVariant: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    narratorImgSrc: '',
    narratorImgSrc2: '',
    style: {},
    style2: {},
    srcConfirmedLoaded: false,
    use1: false,
  }),
  computed: {
    ...mapGetters([
      'selectedAvatar',
      'proxyAvatar',
      'narrative',
      'game',
      'starfighter',
      'native'
    ]),
    avatar() {
      return this.proxyAvatar || this.selectedAvatar;
    },
    variant() {
      let variantName = this.variantOverride;

      if (
        !(variantName) && this.narrative != null &&
        this.avatar.imageVariants &&
        this.avatar.imageVariants.length > 0
      ) {
        if (!(this.right) && this.narrative.leftVariant) variantName = this.narrative.leftVariant;
        else if (this.right && this.narrative.rightVariant) variantName = this.narrative.rightVariant;
      }

      if (variantName && this.avatar.imageVariants != null) {
        const variant = this.avatar.imageVariants.find(v => v.name === variantName);
        return variant;
      }

      return null;
    },
    imageVariant() {
      if (this.variant) return this.variant.image;

      return null;
    },
    avatarImage() {
      let image =
        (this.angled && this.avatar.imageAngled)
          ? this.avatar.imageAngled
          : this.avatar.image;
      if (this.imageVariant) image = this.imageVariant;
      return this.resolveAssetPath(image, 'characters');
    },
    order() {
      if (this.orderOverride) {
        return this.orderOverride;
      }
      if (this.narrative == null) {
        return 0;
      }
      return (this.right) ? this.narrative.rightOrderOverride : this.narrative.leftOrderOverride;
    },
    leftXOffset() {
      if (this.xOffset || this.narrative == null) {
        return this.xOffset;
      }
      return this.narrative.leftXOffset;
    },
    rightXOffset() {
      if (this.xOffset || this.narrative == null) {
        return this.xOffset;
      }
      return this.narrative.rightXOffset;
    },
    leftYOffset() {
      if (this.yOffset || this.narrative == null) {
        return this.yOffset;
      }
      return this.narrative.leftYOffset;
    },
    rightYOffset() {
      if (this.yOffset || this.narrative == null) {
        return this.yOffset;
      }
      return this.narrative.rightYOffset;
    },
    computedStyle() {
      let rightVal;
      let leftVal;
      if (!(this.right)) {
        leftVal = (this.variant != null)
          ? this.variant.xOffset
          : (this.avatar != null ? this.avatar.xOffset : undefined);
        if (this.leftXOffset) {
          leftVal = leftVal ? `calc(${leftVal} + ${this.leftXOffset})` : this.leftXOffset;
        }
      } else {
        rightVal = (this.variant != null)
          ? this.variant.xOffset
          : (this.avatar != null ? this.avatar.xOffset : undefined);
        if (this.rightXOffset) {
          rightVal = rightVal ? `calc(${rightVal} + ${this.rightXOffset})` : this.rightXOffset;
        }
      }
      let bottomVal = (this.variant != null && this.variant.yOffset)
        ? this.variant.yOffset
        : ((this.variant == null && this.avatar != null && this.avatar.yOffset)
          ? this.avatar.yOffset
          : undefined);
      if (!(this.right) && this.leftYOffset) {
        bottomVal = bottomVal ? `calc(${bottomVal} + ${this.leftYOffset})` : this.leftYOffset;
      } else if (this.right && this.rightYOffset) {
        bottomVal = bottomVal ? `calc(${bottomVal} + ${this.rightYOffset})` : this.rightYOffset;
      }
      return {
        transform: `scale(${this.scale * ((this.right && this.variant == null) ? -1 : 1)}, ${this.scale})`,
        position: 'relative',
        right: rightVal,
        left: leftVal,
        bottom: bottomVal
      };
    }
  },
  watch: {
    avatarImage(newValue) {
      // console.log(`${this.tooltipTarget} - narratorImg change`);
      this.srcConfirmedLoaded = false;
      if (this.use1) {
        if (this.narratorImgSrc2 === newValue) this.onLoaded();
        else this.narratorImgSrc2 = newValue;
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.narratorImgSrc === newValue) this.onLoaded();
        else this.narratorImgSrc = newValue;
      }
    },
    computedStyle(newValue) {
      // console.log(`${this.tooltipTarget} - computedStyle change`);
      // console.log(this.srcConfirmedLoaded);
      // console.log(this.use1);
      if (this.srcConfirmedLoaded) {
        if (this.use1) this.style = newValue;
        else this.style2 = newValue;
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.use1) this.style2 = newValue;
        else this.style = newValue;
      }
    },
  },
  methods: {
    onLoaded() {
      // console.log(`${this.tooltipTarget} - onLoaded`);
      this.srcConfirmedLoaded = true;
      if (this.use1) this.style2 = this.computedStyle;
      else this.style = this.computedStyle;
      this.use1 = !(this.use1);
    },
  },
  async mounted() {
    // console.log('narratorImg init');
    this.narratorImgSrc = this.avatarImage;
    // console.log('style init');
    this.style = this.computedStyle;
  }
};
</script>

<style lang="scss" scoped>
.player {
  pointer-events: none;
  position: absolute;
  // transition: bottom 1s;
  // transition: all 0.3s ease-in-out;

  // new position parameters
  left: -174px;
  top: 0;
  height: 1950px;
}
.player.sf {
  left: -10px;
  height: unset !important;
  top: unset !important;
  bottom: -280px !important;

  pointer-events: none;
}
.player img {
  pointer-events: none;
  max-height: 100%;
  object-fit: contain;
}
// .player.full {
//   bottom: -280px;
// }
.player.right {
  left: unset;

  // new position parameter
  right: -174px;
}
.player.right.sf {
  // old position parameter
  right: -60px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/Player.vue